import {
  ApiRequestsContext,
  ApiRequestsTypes,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { InlineDescriptionEditor } from '../InlineDescriptionEditor';


export interface ColumnInlineDescriptionEditorProps {
  readonly canEditDescription: boolean;
  readonly columnVizportalId: string | null;
  readonly description: string;
  readonly afterDescriptionChange: () => void;
}

export function ColumnInlineDescriptionEditor(props: ColumnInlineDescriptionEditorProps): JSX.Element {
  const apiRequests = React.useContext(ApiRequestsContext);

  const setDescription = async (inputText: string) => {
    const args: ApiRequestsTypes.SetColumnDescriptionArgs = {
      columnVizportalId: props.columnVizportalId ?? '',
      description: inputText
    };

    return await apiRequests.setColumnDescription(args);
  };

  return (
    <InlineDescriptionEditor
      canEdit={props.canEditDescription}
      onSave={setDescription}
      initialDescription={props.description}
      afterSave={props.afterDescriptionChange}
    />
  );
}
